import Icon from "./Icon";

export default function FiltersBar({ q, setQ, roleFilter, setRoleFilter }) {
  return (
    <div className="rounded-2xl border bg-white p-5 flex flex-col md:flex-row md:items-end gap-3">
      <div className="flex-1">
        <label className="block text-xs font-medium text-slate-700 mb-1">Search</label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            <Icon name="search" className="w-4 h-4" />
          </span>
          <input
            className="w-full border rounded-xl pl-9 pr-3 py-2.5 focus:outline-none focus:ring-2 focus:ring-sky-200"
            placeholder="Search by email…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
        </div>
      </div>

      <div className="w-full md:w-64">
        <label className="block text-xs font-medium text-slate-700 mb-1">Role filter</label>
        <select
          className="w-full border rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200"
          value={roleFilter}
          onChange={(e) => setRoleFilter(e.target.value)}
        >
          <option value="ALL">All roles</option>
          <option value="DOCTOR">Doctor</option>
          <option value="STAFF">Staff</option>
          <option value="NONE">No role</option>
        </select>

        {/* <div className="mt-1 text-[11px] text-slate-500">
          Role filtering works only if your GET endpoint returns <code>role</code>.
        </div> */}
      </div>
    </div>
  );
}
